import { forwardRef } from 'react';
import type { ReactNode } from 'react';
import { Close } from '@radix-ui/react-dialog';
import type { DialogCloseProps as RadixClose } from '@radix-ui/react-dialog';

type DialogCloseProps = RadixClose & {
  children: ReactNode;
  className?: string;
};

export const DialogClose = forwardRef<HTMLButtonElement, DialogCloseProps>(({ children, className, ...rest }, ref) => (
  <Close {...rest} ref={ref} className={className}>
    {children}
  </Close>
));
